import i18n from '@/i18n';
export default [
  // 产品管理
  {
    path: '/device/list',
    name: 'device',
    component:()=>import("@/views/device"),
    meta: {
      requireAuth: false,
      active: 'device/list',
      noAuth: false,
      bread: [
        { name: i18n.t('HT.router.device'), icon: 'ux_icon_authority' },
        { name: i18n.t('HT.router.deviceList') }
      ]
    }
  },
  {
    path: '/device/detail',
    name: 'deviceDetail',
    component:()=>import("@/views/device/detail"),
    meta: {
      requireAuth: false,
      active: 'device/list',
      noAuth: false,
      bread: [
        { name: i18n.t('HT.router.device') },
        { name: i18n.t('HT.router.deviceList'), url: '/device/list'},
        { name: i18n.t('HT.router.deviceDetail') },
      ]
    }
  },
  {
    path: '/device/log',
    name: 'deviceLog',
    component:()=>import("@/views/device/log"),
    meta: {
      requireAuth: false,
      active: 'device/log',//这里的active是path，并且不用最前面的/
      noAuth: false,
      bread: [
        { name: i18n.t('HT.router.device')},
        { name: i18n.t('HT.router.deviceCallLog') }
      ]
    }
  }
];
